import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconStarOn = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M12.68 2.50006L14.69 9.04006H21.29C21.97 9.04006 22.26 9.91006 21.72 10.3301L16.35 14.4601L18.38 21.0701C18.58 21.7401 17.82 22.2701 17.27 21.8501L12 17.8001L6.73005 21.8501C6.18005 22.2701 5.41005 21.7401 5.62005 21.0701L7.65005 14.4601L2.28005 10.3301C1.74005 9.91006 2.03005 9.04006 2.71005 9.04006H9.31005L11.32 2.50006C11.53 1.83006 12.47 1.83006 12.68 2.50006Z" }))));
};
